import { Controller } from "@hotwired/stimulus"
import { formValidation, plugins } from "formvalidation"
import Bootstrap3 from "formvalidation/plugins/Bootstrap3"

export default class extends Controller {
  static targets = [
    "directModal",
    "form",
    "mapToText",
    "organizationSelect",
    "microsoftOauthButtonEnabled",
    "microsoftOauthButtonDisabled",
  ]

  connect() {
    this.initializeSelect2()
    this.setupFormValidation()
  }

  setupFormValidation() {
    const validationObject = (message, callback = (input) => input.value !== "") => ({
      validators: { callback: { message, callback } }
    })

    const pluginsObject = () => ({
      bootstrap3: new Bootstrap3(),
      icon: new plugins.Icon({
        valid: "glyphicon glyphicon-ok",
        invalid: "glyphicon glyphicon-remove",
        validating: "glyphicon glyphicon-refresh"
      }),
      trigger: new plugins.Trigger({ event: "input blur" })
    })

    this.organizationSelectFv = formValidation(this.formTarget, {
      plugins: pluginsObject(),
      fields: {
        "#organization_id": validationObject("Organization is required."),
      }
    })
  }

  initializeSelect2() {
    const select2 = $(this.organizationSelectTarget).select2({
      theme: "bootstrap",
      placeholder: "Select Huntress Organization",
      width: "100%",
      allowClear: true
    })
    select2.val("").trigger("change")
    select2.on("select2:select", this.toggleMicrosoftButton.bind(this, true))
    select2.on("select2:unselect", this.toggleMicrosoftButton.bind(this, false))
  }

  submitForm() {
    const callback = (result) => { if (result === "Valid") this.formTarget.submit() }

    this.organizationSelectFv.validate().then(callback.bind(this))
  }

  toggleMicrosoftButton(enable) {
    const enabledBtn = this.microsoftOauthButtonEnabledTarget
    const disabledBtn = this.microsoftOauthButtonDisabledTarget

    if (enable) {
      enabledBtn.style.display = "block"
      disabledBtn.style.display = "none"
    } else {
      enabledBtn.style.display = "none"
      disabledBtn.style.display = "block"
    }
  }
}
